import { IMerchant } from "@interfaces";
import liff from "@line/liff";
import { selectMerchant } from "@redux";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { getLiffId } from "src/Utils/getLiffId";

export const PageLiffScanQrcode = () => {
    const history = useHistory();
    const { id } = useParams<{ id: string }>();
    const merchant = useSelector(selectMerchant);

    const openLiff = async () => {
        const liffUrl = await liff.permanentLink.createUrlBy(window.location.href);
        // alert(liffUrl);
        window.location.href = liffUrl;
        // setTimeout(handleLineScan, 200);
        // handleLineScan();
    };
    const checkBrowser = async () => {
        await null;
        const userAgent = navigator.userAgent;
        let lowerText: string = userAgent.toLowerCase();
        if (
            lowerText.includes("line")
            // && lowerText.includes('android')
        ) {
            // from line android
            // await initializeLiff();
            // alert("in line");

            liff.init({ liffId: getLiffId(merchant as IMerchant) }).then(() => {
                if (!liff.isInClient()) {
                    openLiff();
                } else handleLineScan();
            });
        }
    };
    const handleLineScan = async () => {
        try {
            const result = await liff.scanCodeV2();
            console.log("Scanned code:", result);
            if (result?.value) {
                // setSellerCode(result?.value);
                sessionStorage.setItem("READ_SCANNER", result?.value);
                history.push(id);
            }

            // alert(result.value);
        } catch (err) {
            console.error(err);
            alert(err);
        }
    };

    useEffect(() => {
        checkBrowser();
        if (sessionStorage.getItem("READ_SCANNER")) {
            history.push(id);
        }
    }, []);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            }}
        >
            <button
                onClick={() => handleLineScan()}
                style={{ width: "300px", height: "45px", textAlign: "center" }}
            >
                Open Camera
            </button>
        </div>
    );
};
